import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import GeneralTooltipsTooltipEvents from 'lumen/components/general/tooltips/tooltip-events';
import type { Holiday, Period } from 'lumen/models';

interface GeneralTooltipsTooltipRatesEvolutionHeaderSectionSignature {
  Args: {
    period?: Period;
  };
}

export default class GeneralTooltipsTooltipRatesEvolutionHeaderSection extends Component<GeneralTooltipsTooltipRatesEvolutionHeaderSectionSignature> {
  @service declare access: Services['access'];

  get holidays(): Holiday[] {
    const { period } = this.args;

    if (period?.day?.holidays) {
      return [...period.day.holidays];
    }

    return [];
  }

  <template>
    {{#if this.access.hasEvents}}
      <GeneralTooltipsTooltipEvents
        @events={{@period.day.calendarEvents}}
        @holidays={{this.holidays}}
        @title="market_insight.detail_pane.tabs.events_holidays"
      />
    {{/if}}
  </template>
}
